import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-pause\"><rect x=\".5\" y=\".5\" width=\"29\" height=\"29\" rx=\"14.5\" fill=\"#fff\" stroke=\"currentColor\" /><path d=\"M12.5 20.5h-1V10h1v10.5Zm6 0h-1V10h1v10.5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol